import { useTranslation } from '@/i18n';
import classnames from 'classnames/bind';
import { FC } from 'react';
import styles from './styles.module.scss';

const cx = classnames.bind(styles);

export const Contents: FC = () => {
  const { t } = useTranslation();
  return (
    <div className={cx('container')}>
      <span className={cx('text')}>
        {t('received_invoice_reconciliation_send_confirm_body')}
      </span>
    </div>
  );
};
